import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import csTranslation from "./cs/translation.json";
import enTranslation from "./en/translation.json";

i18next.use(initReactI18next).init({
    lng: "en",
    fallbackLng: "cs",
    debug: import.meta.env.VITE_I18N_DEBUG === "true",
    // React already escapes JSX text content, so i18next's own HTML-entity escaping of
    // interpolated values (e.g. "/" -> "&#x2F;") is redundant — and actively wrong, since it
    // shows up as literal entities instead of being decoded (React doesn't parse HTML entities
    // in plain text nodes).
    interpolation: {
        escapeValue: false,
    },
    resources: {
        en: {
            translation: enTranslation,
        },
        cs: {
            translation: csTranslation,
        },
    },
});
